import localForage from "localforage";
import { AUTH_SIGN_IN_SUCCESS } from './authActions';
import { handleErrors } from "../helpers/error";

export const ACCOUNT_REGISTER = 'ACCOUNT_REGISTER';
export const ACCOUNT_REGISTER_SUCCESS = 'ACCOUNT_REGISTER_SUCCESS';
export const ACCOUNT_REGISTER_ERROR = 'ACCOUNT_REGISTER_ERROR';

export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE';
export const ACCOUNT_UPDATE_SUCCESS = 'ACCOUNT_UPDATE_SUCCESS';
export const ACCOUNT_UPDATE_ERROR = 'ACCOUNT_UPDATE_ERROR';

export const ACCOUNT_DETAIL = 'ACCOUNT_DETAIL';
export const ACCOUNT_DETAIL_SUCCESS = 'ACCOUNT_DETAIL_SUCCESS';
export const ACCOUNT_DETAIL_ERROR = 'ACCOUNT_DETAIL_ERROR';




export const register = (formData) => {
  console.log(formData, "formData")
  const {
    account_type,
    gender,
    address,
    city,
    height,
    weight,
    birthday,
    postal_code,
    mobile_phone_number,
    alternative_phone_number,
    has_different_delivery_address,
    preferred_delivery_time,
    address_has_doorkeeper,
    work_status,
    how_you_know_about_cosmocare,
    using_social_networks,
    social_security_affiliation,
    health_problems,
    disease_type_other,
    derma_affections,
    derma_affections_answer,
    prone_to_conjunctivitis,
    prone_to_herpes,
    prone_to_allergic_rhinitis,
    prone_to_asthma_crisis,
    intolerance_reaction_cosmetics,
    skin_type,
    skin_nature,
    sensitive_facial_skin,
    skin_characteristics,
    skin_characteristics_other,
    lips_nature,
    sensitive_lips,
    body_skin_nature,
    have_cellulite,
    have_cellulite_value,
    sensitive_body_skin,
    has_stretch_marks,
    has_pigmentation_spots_neckline,
    hand_skin_nature,
    has_sensitive_hands,
    has_pigmentation_spots_on_hands,
    has_sensitive_eyes,
    wear_glasses,
    wear_contact_lenses,
    had_eyes_problems,
    has_sensitive_scalp,
    scalp_nature,
    hair_nature,
    hair_state,
    hair_type,
    hair_color,
    hair_length,
    dyed_hair,
    hair_loss,
    hair_dandruff,
    facial_skin_atopic_tendency,
    consumer_usual_products,
    use_hair_removal_products,
    use_bio_products,
    is_smoking,
    smoking_user_input,
    has_tattoos,
    has_tattoos_value,
    enrolled_in_other_center,
    had_recent_surgery,
    email,
    password,
    first_name,
    you_take_medicine,
    last_name,
    second_last_name,
    policies,
    social_networks,
    social_networks_other,
    hair_removal_zones,
    hair_removal_methods,
    delivery_address,
    work_status_other,
    how_you_know_about_cosmocare_other,
    why_participate_in_tests,
    intolerance_reaction_cosmetics_value,
    had_recent_surgery_value,
    had_eyes_problems_value,
    buy_products_from,
    buy_products_from_other,
    consumer_usual_products_other,
  } = formData;

  let ac_type, gender_, ac_type_;


  account_type === "1" ? (ac_type = "vc_profile", ac_type_ = "volunteer") : (ac_type = "vc_profile", ac_type_ = "consumer");
  gender === "0" ? gender_ = "male" : gender_ = "female";
  const datafake = {
    "account_type": ac_type,
    [ac_type]: {
      "account_type": ac_type_,
      "address": address,
      "city": city,
      "gender": gender_,
      "height": height,
      "weight": weight,
      "birthday": birthday,
      "postal_code": postal_code,
      "mobile_phone_number": mobile_phone_number,
      "alternative_phone_number": alternative_phone_number,
      "has_different_delivery_address": has_different_delivery_address === "1" ? false : true,
      "preferred_delivery_time": preferred_delivery_time,
      "address_has_doorkeeper": address_has_doorkeeper === "2" ? true : false,
      "work_status": work_status,
      "how_you_know_about_cosmocare": how_you_know_about_cosmocare,
      "using_social_networks": using_social_networks === "2" ? true : false,
      "social_security_affiliation": social_security_affiliation === "2" ? true : false,
      "health_problems": health_problems,
      "disease_type_other":disease_type_other,
      "derma_affections": derma_affections,
      "derma_affections_answer": derma_affections_answer,
      "prone_to_conjunctivitis": prone_to_conjunctivitis === "2" ? true : false,
      "prone_to_herpes": prone_to_herpes === "2" ? true : false,
      "prone_to_allergic_rhinitis": prone_to_allergic_rhinitis === "2" ? true : false,
      "prone_to_asthma_crisis": prone_to_asthma_crisis === "2" ? true : false,
      "intolerance_reaction_cosmetics": intolerance_reaction_cosmetics === "2" ? true : false,
      "skin_type": skin_type,
      "skin_nature": skin_nature,
      "hair_removal_methods": hair_removal_methods,
      "hair_removal_zones": hair_removal_zones,
      "sensitive_facial_skin": sensitive_facial_skin === "2" ? true : false,
      "facial_skin_atopic_tendency": facial_skin_atopic_tendency === "2" ? true : false,
      "skin_characteristics": skin_characteristics,
      "lips_nature": lips_nature,
      "sensitive_lips": sensitive_lips === "2" ? true : false,
      "body_skin_nature": body_skin_nature,
      "sensitive_body_skin": sensitive_body_skin === "2" ? true : false,
      "have_cellulite": have_cellulite === "2" ? true : false,
      "have_cellulite_value":have_cellulite_value,
      "has_stretch_marks": has_stretch_marks === "2" ? true : false,
      "has_pigmentation_spots_neckline": has_pigmentation_spots_neckline === "2" ? true : false,
      "hand_skin_nature": hand_skin_nature,
      "has_sensitive_hands": has_sensitive_hands === "2" ? true : false,
      "has_pigmentation_spots_on_hands": has_pigmentation_spots_on_hands === "2" ? true : false,
      "has_sensitive_eyes": has_sensitive_eyes === "2" ? true : false,
      "wear_glasses": wear_glasses === "2" ? true : false,
      "wear_contact_lenses": wear_contact_lenses === "2" ? true : false,
      "had_eyes_problems": had_eyes_problems === "2" ? true : false,
      "has_sensitive_scalp": has_sensitive_scalp === "2" ? true : false,
      "scalp_nature": scalp_nature,
      "hair_nature": hair_nature,
      "hair_state": hair_state,
      "hair_type": hair_type,
      "hair_color": hair_color,
      "you_take_medicine": you_take_medicine,
      "hair_length": hair_length,
      "dyed_hair": dyed_hair === "2" ? true : false,
      "hair_loss": hair_loss === "2" ? true : false,
      "hair_dandruff": hair_dandruff === "2" ? true : false,
      "consumer_usual_products": consumer_usual_products,
      "use_hair_removal_products": use_hair_removal_products === "2" ? true : false,
      "use_bio_products": use_bio_products === "2" ? true : false,
      "is_smoking": is_smoking === "2" ? true : false,
      "smoking_user_input": smoking_user_input,
      "has_tattoos": has_tattoos === "2" ? true : false,
      "has_tattoos_value": has_tattoos_value,
      "enrolled_in_other_center": enrolled_in_other_center === "2" ? true : false,
      "had_recent_surgery": had_recent_surgery === "2" ? true : false,
      "social_networks": social_networks,
      "social_networks_other": social_networks_other,
      "delivery_address": delivery_address,
      "work_status_other": work_status_other,
      "how_you_know_about_cosmocare_other": how_you_know_about_cosmocare_other,
      "consumer_usual_products_other": consumer_usual_products_other,
      "buy_products_from":buy_products_from,
      "buy_products_from_other": buy_products_from_other,
      "why_participate_in_tests": why_participate_in_tests,
      "intolerance_reaction_cosmetics_value": intolerance_reaction_cosmetics_value,
      "had_recent_surgery_value": had_recent_surgery_value,
      "had_eyes_problems_value": had_eyes_problems_value,
      "skin_characteristics_other": skin_characteristics_other
    },
    "email": email,
    "password": password,
    "first_name": first_name,
    "last_name": last_name,
    "second_last_name": second_last_name,
    "policies": policies
  }

  console.log(has_different_delivery_address,"pasha 1", datafake)
  return {
    type: ACCOUNT_REGISTER,
    payload: {
      request: {
        url: 'auth/signup/',
        data: datafake,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Accept-Language': 'es'
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('account', response.data).then(() => {
            dispatch(account_detail(response.data.user_id))
            dispatch({ type: ACCOUNT_REGISTER_SUCCESS, payload: response.data });
            dispatch({
              type: AUTH_SIGN_IN_SUCCESS,
              payload: response.data
            });
            dispatch({ type: ACCOUNT_UPDATE_SUCCESS, payload: response.data });

          })
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';
          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          handleErrors(message, dispatch);
        },
      }
    }
  }
}


export const registerVolontarius = (formData) => {
  console.log(formData, "formData  Volontarius")
  const {
    email,
    password,
    first_name,
    last_name,
    second_last_name,
    birthday,
    you_take_medicine,
    country_of_birth,
    region_of_birth,
    city_of_birth,
    nationality,
    dni,
    has_children,
    accept_children_to_test,
    address,
    city,
    postal_code,
    mobile_phone_number,
    alternative_phone_number,
    test_type,
    test_application_zone,
    contact_method,
    contact_time,
    account_type,
    disease_type,
    disease_type_other,
    immunosuppressive_treatment,
    other_treatment,
    other_treatment_description,
    legal_drug,
    organ_transplant,
    had_surgery,
    had_surgery_description,
    cranial_trauma,
    contraception,
    skin_affection,
    has_allergies,
    has_allergies_user_input,
    family_has_allergies,
    family_has_allergies_user_input,
    reactions_to_insect_bites,
    reactions_to_sun,
    food_allergies,
    food_allergies_user_input,
    drug_allergies,
    drug_allergies_user_input,
    cosmetic_product_allergies,
    cosmetic_product_allergies_description_product,
    cosmetic_product_allergies_description_body_zone,
    possible_affections,
    allergic_reactions_to,
    gender,
    height,
    weight,
    is_smoking,
    smoking_user_input,
    has_tattoos,
    has_tattoos_value,
    enrolled_in_other_center,
    social_security_affiliation,
    health_and_care_products,
    consumer_usual_products_other,
    hair_removal_products,
    hair_removal_zones,
    hair_removal_products_list,
    had_laser_hair_removal,
    had_laser_hair_removal_user_input,
    skin_affection_answer,
    possible_affections_answer,
    health_and_care_products_answer,
    hair_removal_zones_laser,
    use_hair_removal_products,
  } = formData;

  let ac_type, gender_, ac_type_;
  account_type === "1" ? (ac_type = "vc_profile", ac_type_ = "volunteer") : (ac_type = "vc_profile", ac_type_ = "consumer");
  gender === "0" ? gender_ = "male" : gender_ = "female";
  console.log("================", formData);
  const datafake = {
    "account_type": ac_type,
    [ac_type]: {
      "skin_affection_answer":skin_affection_answer,
      "possible_affections_answer":possible_affections_answer,
      "health_and_care_products_answer":health_and_care_products_answer,
      "account_type": ac_type_,
      "birthday": birthday,
      "country_of_birth": country_of_birth,
      "region_of_birth": region_of_birth,
      "city_of_birth": city_of_birth,
      "nationality": nationality,
      "dni": dni,
      "has_children": has_children,
      "accept_children_to_test": accept_children_to_test,
      "address": address,
      "city": city,
      "postal_code": postal_code,
      "mobile_phone_number": mobile_phone_number,
      "alternative_phone_number": alternative_phone_number,
      "test_type": test_type,
      "test_application_zone": test_application_zone,
      "contact_method": contact_method,
      "contact_time": contact_time,
      "disease_type": disease_type,
      "disease_type_other":disease_type_other,
      "immunosuppressive_treatment": immunosuppressive_treatment === "Sí" ? true : false,
      "other_treatment": other_treatment === "Sí" ? true : false,
      "other_treatment_description": other_treatment_description,
      "legal_drug": legal_drug,
      "organ_transplant": organ_transplant === "Sí" ? true : false,
      "had_surgery": had_surgery === "Sí" ? true : false,
      "had_surgery_description": had_surgery_description,
      "cranial_trauma": cranial_trauma === "Sí" ? true : false,
      "contraception": contraception === "Sí" || contraception === "No" ? contraception === "Sí" ? true : false : undefined,
      "skin_affection": skin_affection,
      "you_take_medicine": you_take_medicine,
      "has_allergies": has_allergies === "Sí" ? true : false,
      "has_allergies_user_input": has_allergies_user_input,
      "family_has_allergies": family_has_allergies === "Sí" ? true : false,
      "family_has_allergies_user_input": family_has_allergies_user_input,
      "reactions_to_insect_bites": reactions_to_insect_bites === "Sí" ? true : false,
      "reactions_to_sun": reactions_to_sun === "Sí" ? true : false,
      "food_allergies": food_allergies === "Sí" ? true : false,
      "food_allergies_user_input": food_allergies_user_input,
      "drug_allergies": drug_allergies === "Sí" ? true : false,
      "drug_allergies_user_input": drug_allergies_user_input,
      "cosmetic_product_allergies": cosmetic_product_allergies === "Sí" ? true : false,
      "cosmetic_product_allergies_description_product": cosmetic_product_allergies_description_product,
      "cosmetic_product_allergies_description_body_zone": cosmetic_product_allergies_description_body_zone,
      "possible_affections": possible_affections,
      "allergic_reactions_to": allergic_reactions_to,
      "gender": gender_,
      "height": height,
      "weight": weight,
      "is_smoking": is_smoking=== "Sí" ? true : false,
      "smoking_user_input": smoking_user_input,
      "has_tattoos": has_tattoos === "Sí" ? true : false,
      "has_tattoos_value": has_tattoos_value,
      "enrolled_in_other_center": enrolled_in_other_center === "Sí" ? true : false,
      "social_security_affiliation": social_security_affiliation === "Sí" ? true : false,
      "health_and_care_products": health_and_care_products,
      "consumer_usual_products_other": consumer_usual_products_other,
      "hair_removal_products": hair_removal_products === "Sí" ? true : false,
      "hair_removal_zones": hair_removal_zones,
      "hair_removal_products_list": hair_removal_products_list,
      "had_laser_hair_removal": had_laser_hair_removal === "Sí" ? true : false,
      "had_laser_hair_removal_user_input": had_laser_hair_removal_user_input,
      "hair_removal_zones_laser": hair_removal_zones_laser,
      "use_hair_removal_products": use_hair_removal_products === "Sí" ? true : false,
    },
    "email": email,
    "password": password,
    "first_name": first_name,
    "last_name": last_name,
    "second_last_name": second_last_name,
  }

  console.log("----------datafake-----------", datafake)
  return {
    type: ACCOUNT_REGISTER,
    payload: {
      request: {
        url: 'auth/signup/',
        data: datafake,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Accept-Language': 'es'
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('account', response.data).then(() => {
            dispatch(account_detail(response.data.user_id))
            dispatch({ type: ACCOUNT_REGISTER_SUCCESS, payload: response.data });
            dispatch({
              type: AUTH_SIGN_IN_SUCCESS,
              payload: response.data
            });
          })
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';
          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          handleErrors(message, dispatch);
        },
      }
    }
  }
}

export const account_detail = (user_id) => {
  return (dispatch) => {
    localForage.getItem('account').then((response) => {
      console.log(response);
      dispatch({
        type: ACCOUNT_DETAIL,
        payload: {
          request: {
            url: 'vcprofiles/' + user_id + '/',
            headers: {
              'Authorization': 'Token ' + response.token
            }
          },
          options: {
            onSuccess({ getState, dispatch, response }) {
              dispatch({ type: ACCOUNT_DETAIL_SUCCESS, payload: response });
            },
            onError({ getState, dispatch, error }) {
              dispatch({ type: ACCOUNT_DETAIL_ERROR, payload: error.message });
            },
          }
        }
      });
    });
  };
};

export const account_update = (formData, user_id, token, _func) => {
  const {
    first_name,
    last_name,
    second_last_name,
    birthday,
    weight,
    wear_glasses,
    wear_contact_lenses,
    enrolled_in_other_center,
    had_recent_surgery,
    had_recent_surgery_value,
    consumer_usual_products,
    consumer_usual_products_other,
    use_hair_removal_products,
    hair_removal_zones,
    hair_removal_products_list,
    has_tattoos,
    has_tattoos_value,
  } = formData;

  const datafake = {
    // user: {
    //   first_name: first_name,
    //   last_name: last_name,
    //   second_last_name: second_last_name, 
    // },
    // mobile_phone_number: mobile_phone_number,
    birthday: birthday,
    weight:weight,
    wear_glasses:wear_glasses=== "1" ? false : true,
    wear_contact_lenses:wear_contact_lenses=== "1" ? false : true,
    enrolled_in_other_center:enrolled_in_other_center=== "1" ? false : true,
    had_recent_surgery:had_recent_surgery=== "1" ? false : true,
    had_recent_surgery_value:had_recent_surgery_value,
    consumer_usual_products:consumer_usual_products,
    consumer_usual_products_other:consumer_usual_products_other,
    use_hair_removal_products:use_hair_removal_products=== "1" ? false : true,
    hair_removal_zones:hair_removal_zones,
    hair_removal_products_list:hair_removal_products_list,
    has_tattoos:has_tattoos === "1" ? false : true,
    has_tattoos_value:has_tattoos_value    
  };
  // console.log(formData, "datafake", datafake)
  return {
    type: ACCOUNT_UPDATE,
    payload: {
      request: {
        url: 'vcprofiles/' + user_id + '/',
        data: datafake,
        method: 'put',
        headers: {
          'Authorization': 'Token ' + token
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('auth', response.data).then(() => {
            // console.log(response.data);
            dispatch({ type: ACCOUNT_UPDATE_SUCCESS, payload: response.data });
            dispatch(account_detail(response.data.id))
            _func(true);
          })
          return true;
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';

          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          handleErrors(message, dispatch);
        },
      }
    }
  }
}

export const account_update_volontario = (formData, user_id, token, _func) => {
  const datafake = {
    user: {
      email: formData.email,
      id: user_id,
    },
    mobile_phone_number: formData.mobile_phone_number,
    has_tattoos: formData.has_tattoos === "1" ? false : true,
    has_tattoos_value: formData.has_tattoos_value,
    weight: formData.weight,
    health_and_care_products: formData.health_and_care_products,
    consumer_usual_products_other: formData.consumer_usual_products_other,
    use_hair_removal_products: formData.use_hair_removal_products === "1" ? false : true,
    hair_removal_zones: formData.hair_removal_zones,
    hair_removal_products_list: formData.hair_removal_products_list,
    had_laser_hair_removal: formData.had_laser_hair_removal === "1" ? false : true,
    had_laser_hair_removal_user_input: formData.had_laser_hair_removal_user_input,
    health_and_care_products_answer: formData.health_and_care_products_answer,
  };
  console.log(formData, "account_update_volontario--datafake", datafake)
  return {
    type: ACCOUNT_UPDATE,
    payload: {
      request: {
        url: 'vcprofiles/' + formData.id + '/',
        data: datafake,
        method: 'patch',
        headers: {
          'Authorization': 'Token ' + token
        }
      },
      options: {
        onSuccess({ getState, dispatch, response }) {
          localForage.setItem('auth', response.data).then(() => {
            console.log(response.data);
            dispatch({ type: ACCOUNT_UPDATE_SUCCESS, payload: response.data });
            dispatch(account_detail(formData.id))
            _func(true);
          })
          return true;
        },
        onError({ getState, dispatch, error }) {

          let message = 'Network error';

          if (typeof error.response !== 'undefined') {
            message = typeof error.response.data.error !== 'undefined' ? error.response.data.error : 'Error';
          }

          handleErrors(message, dispatch);
        },
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/accountActions.js